export enum Geometry {
  POINT = 'POINT',
  LINESTRING = 'LINESTRING'
}
